import { useSelector } from "react-redux";
import OfferWithElectric from "../../pages/productNew/offerWithElectric";
import styles from "./index.module.scss";

export default function InstallCalculatorPopup() {
  const { data } = useSelector((state) => state.popup);
  const { domainData } = useSelector((state) => state.contacts);
  const product = data?.product;
  const electric = data?.electric;

  if (!product) {
    return <div>Нет данных о товаре.</div>;
  }

  return (
    <div className={styles.Wrapper}>
      <h2>
        Рассчитать стоимость{" "}
        {data?.product.IBLOCK_SECTION_ID === 635 ? "фаркопа" : "электрики"} с
        установкой{" "}
        {domainData.declension && domainData.name !== "Россия"
          ? ` в ${domainData.declension}`
          : ""}
      </h2>
      <OfferWithElectric
        product={product}
        electric={electric}
        isDetail={false}
      />
    </div>
  );
}
